import { Action } from 'redux';
import {
  IBook,
  IDocumentBookCode,
  IUpdateDocumentBookCodeResult,
} from '../../services';

export interface IBookState {
  loading?: boolean;
  books?: IBook[];
  bookAndDocId?: IDocumentBookCode;
  updateDocumentBookCodeResult?: IUpdateDocumentBookCodeResult;
  exceptionMessage?: string;
  message?: string;
}

export enum BookActionEnum {
  FetchBooks = '@@book/FETCH_BOOKS',
  FetchBookSuccess = '@@book/FETCH_BOOK_SUCCESS',
  FetchBookFailed = '@@book/FETCH_BOOK_FAILED',
  FetchBookWithDocIdsByDocIds = '@@book/FETCH_BOOK_BY_DOCIDS',
  FetchBookWithDocIdsByDocIdsSuccess = '@@book/FETCH_BOOK_BY_DOCIDS_SUCCESS',
  FetchBookWithDocIdsByDocIdsFailure = '@@book/FETCH_BOOK_BY_DOCIDS_FAILURE',
  AssociateBookWithDocId = '@@book/ASSOCIATE_BOOK_WITH_DOCID',
  AssociateBookWithDocIdSuccess = '@@book/ASSOCIATE_BOOK_WITH_DOCID_SUCCESS',
  AssociateBookWithDocIdFailure = '@@book/ASSOCIATE_BOOK_WITH_DOCID_FAILURE',
  ClearBookResult = '@@book/CLEAR_BOOK_RESULT'
}

export interface IFetchBookAction
  extends Action<typeof BookActionEnum.FetchBooks> {
  state?: IBookState;
}

export interface IFetchBookSuccessAction
  extends Action<typeof BookActionEnum.FetchBookSuccess> {
  state?: IBookState;
}

export interface IFetchBookFailedAction
  extends Action<typeof BookActionEnum.FetchBookFailed> {
  state?: IBookState;
}

export interface IFetchBookByDocIdsAction
  extends Action<typeof BookActionEnum.FetchBookWithDocIdsByDocIds> {
  state?: IBookState;
}

export interface IFetchBookByDocIdsSuccessAction
  extends Action<typeof BookActionEnum.FetchBookWithDocIdsByDocIdsSuccess> {
  state?: IBookState;
}

export interface IFetchBookByDocIdsFailureAction
  extends Action<typeof BookActionEnum.FetchBookWithDocIdsByDocIdsFailure> {
  state?: IBookState;
}

export interface IAssociateBookWithDocIdAction
  extends Action<typeof BookActionEnum.AssociateBookWithDocId> {
  state?: IBookState;
}

export interface IAssociateBookWithDocIdSuccessAction
  extends Action<typeof BookActionEnum.AssociateBookWithDocIdSuccess> {
  state?: IBookState;
}

export interface IAssociateBookWithDocIdFailureAction
  extends Action<typeof BookActionEnum.AssociateBookWithDocIdFailure> {
  state?: IBookState;
}

export interface IClearBookResultAction
  extends Action<typeof BookActionEnum.ClearBookResult> {
  state?: IBookState;
}

export type BookActions =
  | IFetchBookAction
  | IFetchBookSuccessAction
  | IFetchBookFailedAction
  | IFetchBookByDocIdsAction
  | IFetchBookByDocIdsSuccessAction
  | IFetchBookByDocIdsFailureAction
  | IAssociateBookWithDocIdAction
  | IAssociateBookWithDocIdSuccessAction
  | IAssociateBookWithDocIdFailureAction
  | IClearBookResultAction;
